import { falLocationDot } from 'shared/@generated/icons/falLocationDot';

import { useTranslation } from 'react-i18next';
import { usePetpayFeatures } from 'shared/library/use-petpay-features';

export function usePetpayBuyerFeatures({
  includeComingSoon = true,
}: {
  includeComingSoon?: boolean;
} = {}) {
  const { t } = useTranslation('screens');
  const basePetpayFeatures = usePetpayFeatures();
  const availableFeatures = basePetpayFeatures.filter((item) => !item.comingSoon);
  const comingSoonFeatures = includeComingSoon
    ? basePetpayFeatures.filter((item) => item.comingSoon)
    : [];

  return [
    ...availableFeatures,
    {
      icon: falLocationDot,
      title: t('petpay.for_buyers.free_tractive_gps'),
      description: t('petpay.for_buyers.free_tractive_gps_description'),
    },
    ...comingSoonFeatures,
  ];
}
